import React from 'react';
import img1 from '../assets/images/imagen-1.jpeg';
import img2 from '../assets/images/imagen-2.jpeg';
import img3 from '../assets/images/imagen-3.jpeg';
import img4 from '../assets/images/imagen-4.jpeg';

const About = () => {
  return (
    <section className='about-section'>
      <div className="container py-5">
        <div class="text-center mb-4" data-aos="fade-up" data-aos-offset="200" data-aos-easing="ease-out-cubic" data-aos-duration="2000">
          <h1><i class="fas fa-users m-2"></i><br />
          Quiénes Somos</h1>
        </div>


        {/* Primer bloque */}
        <div className="row align-items-center mb-5">
          <div className="col-md-6 order-1 order-md-1" data-aos="fade-right" data-aos-offset="200" data-aos-easing="ease-out-cubic" data-aos-duration="2000">
            <img src={img1} alt="Residencia de Adultos Mayores" className="img-fluid rounded shadow" />
          </div>
          <div className="col-md-6 order-2 order-md-2" data-aos="fade-left" data-aos-offset="200" data-aos-easing="ease-out-cubic" data-aos-duration="2000">
            <p>
              Hace algunos años atrás, estudiando la carrera, Licenciatura en Gerontología, recorriendo y observando residencias de Adultos Mayores, llegué
              a decir que jamás me haría cargo de una, ya que me parecían instituciones o empresas que lucraban con necesidades de los Adultos y las familias.
              Cuando me llegó la posibilidad de dirigir una, pensé… ¿por qué no hacer algo diferente? Una residencia en cual pueda confiar la familia y la persona
              que vendría a vivir; y a partir de ahí supe que ese Hogar era posible.
            </p>
          </div>
        </div>

        {/* Segundo bloque */}
        <div className="row align-items-center mb-5">
          <div className="col-md-6 order-1 order-md-2 text-end" data-aos="fade-left" data-aos-offset="200" data-aos-easing="ease-out-cubic" data-aos-duration="2000">
            <img src={img2} alt="Equipo de gestión" className="img-fluid rounded shadow" />
          </div>
          <div className="col-md-6 order-2 order-md-1" data-aos="fade-right" data-aos-offset="200" data-aos-easing="ease-out-cubic" data-aos-duration="2000">
            <p>
              Hoy, después de algunos años de gestión y otras capacitaciones que me han dado herramientas para poder desempeñarme en este rol, considero que
              no es una tarea fácil, pero que, cuando encuentras tu vocación y podés desarrollarte profesionalmente con ella; podés alcanzar resultados maravillosos.
            </p>
          </div>
        </div>

        {/* Tercer bloque */}
        <div className="row align-items-center mb-5">
          <div className="col-md-6 order-1 order-md-1" data-aos="fade-right" data-aos-offset="200" data-aos-easing="ease-out-cubic" data-aos-duration="2000">
            <img src={img3} alt="Adultos Mayores" className="img-fluid rounded shadow" />
          </div>
          <div className="col-md-6 order-2 order-md-2" data-aos="fade-left" data-aos-offset="200" data-aos-easing="ease-out-cubic" data-aos-duration="2000">
            <p>
              Tener un hogar, hacer un hogar, pensar un hogar o dirigir un hogar, como antes menciono, no es tarea fácil. Tener el conocimiento de las fragilidades
              del Adulto mayor y sus familias, ayuda mucho a poder desarrollar conscientemente planes de acción con resultados satisfactorios.
            </p>
          </div>
        </div>

        {/* Cuarto bloque */}
        <div className="row align-items-center">
          <div className="col-md-6 order-1 order-md-2 text-end" data-aos="fade-left" data-aos-offset="200" data-aos-easing="ease-out-cubic" data-aos-duration="2000">
            <img src={img4} alt="Residencia y cuidados" className="img-fluid rounded shadow" />
          </div>
          <div className="col-md-6 order-2 order-md-1" data-aos="fade-right" data-aos-offset="200" data-aos-easing="ease-out-cubic" data-aos-duration="2000">
            <p>
              Las residencias de larga estadía, para mí, llamadas HOGARES, no solo deben contar con las condiciones edilicias básicas y recurso humano para su
              funcionamiento y habilitación; sino que se debe tener un plus de calidad humana para lograr la EMPATÍA necesaria a fin de obtener los mejores
              resultados. Poder ver al Adulto Mayor de manera HOLÍSTICA, teniendo en cuenta su historia e individualidad, nos permitiría construir líneas de
              acciones para ser facilitadores de salud a la hora de acompañar su envejecimiento.
            </p>
          </div>
        </div>
      </div>
    </section>
  );
};

export default About;
